/**
 * Prevent duplicit content to be available on multiple pages.
 * The first page is the default page without any page number in URL.
 */
const getSanitizedPageNumberAsURLParameter = (pageNumber: number): string =>
  pageNumber === 1 ? '' : pageNumber.toString();

export default getSanitizedPageNumberAsURLParameter;
